/**
 * Reusable stateless form component for Site
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { SelectFromObject, TextInput } from '../../../global/components/forms';

function SiteForm({
  cancelLink
  , disabled
  , formTitle
  , formType
  , fromStudy
  , handleFormChange
  , handleFormSubmit
  , site
  , siteLocations
  , sponsors
  , studies
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Site" : "Update Site";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="">
      <div className="form-container -slim">
        <form name="siteForm" className="site-form" onSubmit={handleFormSubmit}>
          {header}
          
          {/* { sponsors && sponsors.length > 0 ?
              <SelectFromObject
                change={handleFormChange}
                clearable={false}
                disabled={true} // no one should ever change this 
                display={'name'}
                filterable={true}
                label="Sponsor"
                name="_organization"
                items={sponsors ? sponsors : []}
                placeholder="-- Select a Sponsor --"
                required={true}
                selected={site._organization}
                value={'_id'}
              />
            :
              null
          }
          { studies && studies.length > 0 && site._organization && site._organization.length > 0 ?
              <SelectFromObject
                change={handleFormChange}
                clearable={false}
                disabled={true} // no one should ever change this 
                display={'name'}
                filterable={true} 
                label="Study"
                name="_group"
                items={studies ? studies : []}
                placeholder="-- Select a Study --"
                required={true}
                selected={site._group}
                value={'_id'}
              />
            :
              null
          } */}
          { site._organization && site._organization.length > 0 && site._group && site._group.length > 0 ?
              <div>
                <TextInput
                  change={handleFormChange}
                  label="Site name"
                  name="name"
                  // placeholder="Name"
                  required={true}
                  value={site.name}
                />
                <TextInput
                  change={handleFormChange}
                  label="Site Number"
                  name="number"
                  placeholder="Number"
                  required={true}
                  value={site.number}
                />
              </div>
            :
              null
          }
          <hr/>
          <div className="input-group">
            <div className="yt-row space-between">
              <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
              <button className="yt-btn " type="submit" disabled={disabled}> {buttonText} </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

SiteForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , fromStudy: PropTypes.bool
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , site: PropTypes.object.isRequired
  , siteLocations: PropTypes.array
  , sponsors: PropTypes.array
  , studies: PropTypes.array
}

SiteForm.defaultProps = {
  formTitle: ''
  , fromStudy: false
}

export default SiteForm;



// WEBPACK FOOTER //
// modules/site/components/SiteForm.js.jsx